import React from "react";
import { View, StyleSheet, Image, FlatList,  TouchableWithoutFeedback, ActivityIndicator} from "react-native";
import { Surface } from "react-native-paper"
 
// import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';
 
import {connect} from "react-redux";
import {getTestSeriesTestList,clearTestSeriesTestList, checkoutCreateTest, getTestSeriesList,} from "./../../store/action";
import {subscriptionPlanPaymentStatus} from "./../../store/selectors"
import moment from "moment";
// import Icon from 'react-native-vector-icons/dist/Ionicons';
import PaymentButtonComponent from "./../../components/paymentButton";
import { FOR_TEST_SERIES } from "../../store/constants";
import ToasterComponent from './../../components/snackBar_toaster';
// import OfflineHandler from './../OfflineHandler';
import {Text,Styles,
    Button, SlideUp
} from "./../../components/UI-Components";
import Header from './../../components/Header/index';
import { TestSeriesDetailsComponent } from './../../components';
import Container from '@material-ui/core/Container';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { isTestSeriesFree, 
    isTestSeriesTestFree,
    isTestSeriesUserPaid

} from "./testListingValidate";
import AdsScreen from './../Ads';
import Grid from '@material-ui/core/Grid';


const wp = x => typeof x === 'string' ? x : `${x}%`

const _width = window.innerWidth;
const Loader = require('./../../assets/loadingGif.gif');


const testImages = require('./../../assets/Group.png');

const hourGlass = require('./../../assets/hourglass.png'); 
const rightArrow = require('./../../assets/assets_png/rightArrow.png');
const lock = require('./../../assets/assets_png/lock.png');


const testData = [
    {
        id:1,
        image: testImages,
        title: 'SSC - Sentence Improvement Test- 1',
        subjectTitle: ['English'],
        isLock: true,
        date: '17th Dec 2019'
    },
    {
        id:2,
        image: testImages,
        title: 'SSC - Sentence ',
        subjectTitle: ['Aptitude'],
        isLock: false,
        date: '29th Dec 2019'
    },
    {
        id:3,
        image: testImages,
        title: 'SSC - Sentence Improvement Test- 1',
        subjectTitle: ['English', 'General studies'],
        isLock: false,
        date: '17th Jan 2020'
    },
    {
        id:4,
        image: testImages,
        title: 'SSC - Sentence ',
        subjectTitle: ['English','Aptitude'],
        isLock: true,
        date: '11 Feb 2020'
    },
    {
        id:5,
        image: testImages,
        title: 'SSC - Sentence Improvement Test- 1',
        subjectTitle: ['English'],
        isLock: true,
        date: '20th Dec 2019'
    },
    {
        id:5,
        image: testImages,
        title: 'SSC - Sentence Improvement Test- 1',
        subjectTitle: ['English'],
        isLock: true,
        date: '20th Dec 2019'
    },
];

export const DateComponent = ({date}) => {
    if(!(moment(date).isValid())) return null
    return (
        <View style={styles.dateWrapper}>
            <View style={styles.flexRow}>
                <Text style={styles.dayText}>{moment(date).format('ddd') + ', '}</Text>
                <Text style={[styles.dayText]}>{moment(date).format('MMM D')}</Text>
            </View>
            <Text style={styles.timeText}>{moment(date).format('LT')}</Text>
        </View>
    )
}

export const TimerGifComponent = ({count=6}) => {
    return (
        <View style={styles.timerGifWrapper}>
        <View style={styles.flexRow}>
        {
            // Array(count).fill('ios-remove').map((x, index) => <Icon key={index} style={styles.dashIcons} size={6} name={x}></Icon>)
            Array(count).fill('ios-remove').map((x, index) => <Text key={index} style={styles.dashIcons} size={6} name={x}>-</Text>)
        }
    </View>
    <View style={{}}>
       <Image source={hourGlass} style={{width:16, height:16, justifyContent:'center', alignSelf:'center', marginHorizontal: 12}}/>
    </View>
    <View style={styles.flexRow}>
    {
            // Array(count).fill('ios-remove').map((x, index) => <Icon key={index} style={styles.dashIcons} size={6} name={x}></Icon>)
            Array(count).fill('ios-remove').map((x, index) => <Text key={index} style={styles.dashIcons} size={6} name={x}>-</Text>)
        }
    </View>
    </View>
    )
}


const TestListComponent = ({testListTestData, navigation, paymentId, subjectNames=[], showToaster, price, appStoreProductId}) => {
    // console.log(testListTestData);
    const {
        id,
        title,
        mock_series_code,
        mock_test_code,
        start_date_time,
        is_free,
        image_url,
        status,
        sortorder,
        termsconditions,
        updated_at,
        created_at,
        mocktestsubjects,
        actual_price,
        is_discount,
        discount_price,
        mock_series_payment,
        mockSeriesCode,
        schedule,
        


    } = testListTestData;
    console.log((!price || !discount_price || is_free || paymentId) ,"Aslfask")
    return (
   
          
        <div 
            className='test_list' 
            onClick={() =>
                {               
                   navigation.push('/TestDetails', {
                       testData: testListTestData,
                       isTestSeries: true,
                       goBack:true,
                       mockTestSubjects:mocktestsubjects,
                       paymentId:paymentId,
                       price:price,
                       mockSeriesCode: mockSeriesCode,
                       schedule: schedule,
                       appStoreProductId, 
                       title: title
                    })
                 
                }
            }
            >
                    <Image
                        source={{ uri: image_url || 'https://storage.googleapis.com/als-athena.appspot.com/images/3BhkokHawSmaOiiTcmDWJVCezO6XSAJizgPyF4nZ.png' }}
                        style={styles.imageIcon}
                    />
                    <View style={{ marginHorizontal: 10, flexWrap: 'wrap', flexDirection: 'column', }}>

                        <Text
                            ellipsizemode={'tail'}
                            numberOfLines={2}
                            style={styles.title}

                        >{title}</Text>
                        <Text
                            ellipsizemode={'tail'}
                            numberOfLines={2}
                            style={styles.duration}

                        >
                            {moment(start_date_time).format('Do MMM YYYY')}
                        </Text>
                    </View>
                
                    <View style={{ marginLeft: 'auto', alignSelf: 'center', alignItems: 'center', flexDirection: 'row' }}>
                        {
                             !(isTestSeriesFree(price || discount_price) || isTestSeriesTestFree(is_free) || isTestSeriesUserPaid(paymentId)) 
                            ?
                            
                            <Image source={lock}  style={{ marginHorizontal: 4, width: 24, height: 24 }} />
                            : 
                            <Image source={rightArrow} style={{ marginHorizontal: 4, width: 24, height: 24 }}/>
                        }
                    </View>

                </div>
       
    )
}

const TestDetailsComponent = ({seriesDetails, navigate}) => {
    const {
        title,
        mock_series_code,
        actual_price,
        discount_price,
        is_discount,
        exam_code,
        is_daily_test,
        sortorder, 
        is_free,
        mock_tests =[],
        mock_series_payment=[],
        image_url,
        id,
        description,
     //    exam_code,
        exam_name,
        end_date_time,
        start_date_time,

    } = seriesDetails;
    // const start_date_time = '2019-12-24 11:00:00';
    // const end_date_time = "2019-12-26 16:00:00";
    
    const {status=null} =  mock_series_payment && mock_series_payment[0] || {};
    let price = (is_free)  ? 'Free' : is_discount ? '₹' + discount_price + '.00' : ' ';
    const actualPrice = actual_price < 1 ?  'Free' : '₹' + actual_price + '.00';
    return(
        <Surface style={styles.testDetailsCom}>
           <View style={styles.detailsWrapper}>
               <View style={styles.topBox}>
                   <View style={styles.imageComp}>
                       <Image source={{uri:image_url}} style={
                           {
                                width:'100%', 
                                height:'100%', 
                                borderTopLeftRadius:10,
                                // borderTopRightRadius:10,
                                resizeMode:'cover'
                            }}
                        />
                   </View>
                   <View style={styles.seriesTitle}>
                       <View>
                            <Text
                                ellipsizeMode="tail"
                                numberOfLines={2}
                             style={styles.seriesTitleText}
                             >{title}</Text>
                            
                       </View>
                       <View>
                            <Text style={styles.testSeriesExam}>{mock_series_code}</Text>
                            
                       </View>
                      {
                          status ? (
                            <View style={{ }}>

                            <Text style={styles.purchasedText}>Purchased</Text>
                             
                           </View> 
                          ) : (
                            <View style={styles.priceList}>
                                     {
                                         discount_price < 1 && is_discount
                                          ? null 
                                          : 
                                        <Text style={(is_discount || is_free) 
                                            ? 
                                            styles.strikePrice 
                                            : 
                                            {...styles.priceTitle, color: actual_price < 1 ? 
                                                Styles.successColor : '#F5891F' }}>
                                                {actualPrice}</Text>
                                     }
                                     
                                    {
                                        (discount_price >= 1 ) ? 
                                        <Text style={{ ...styles.priceTitle, }}>{price}</Text> 
                                         : !is_discount ? 
                                         null : 
                                          <Text style={{ ...styles.priceTitle, color: Styles.successColor }}>Free</Text>  
                                    }
                                    
                            </View>
                             
                          )
                      }
                   </View>
               </View>
               <View style={styles.dateBox}>
                   <View style={styles.startTime}>
                        {
                            start_date_time ? 
                            <>
                                <DateComponent date={start_date_time} />                            
                            </>
                            : null
                        }
                   </View>
                   <View style={styles.middleBox}>
                            <TimerGifComponent />
                   </View>
                   <View style={styles.endTime}>
                        {
                            end_date_time 
                            ? 
                                <DateComponent date={end_date_time} />  
                            :
                            null
                        }
                    </View>
               </View>
               {/* <View style={styles.dividerLine}></View> */}
               <View style={styles.bottomDetails}>
                 <View style={styles.testCount}>
                     <View style={styles.symbolOfCount}>
                     </View>
                    <View>
                        <Text style={{fontSize: 12, color:Styles.bgLight, marginHorizontal: 8,}}>No of Tests: {' '} 
                            
                        </Text>
                    </View>
                    <View>
                    <Text style={styles.count}>{ mock_tests.length <= 9 ? `0${mock_tests.length}` : mock_tests.length}</Text>
                    </View>
                 </View>
                 <TouchableWithoutFeedback   
                        onPress={() => {
                            // console.log(description)
                           
                             navigate.push('FullScreenWebView', {
                                 description: description,
                                 title: title
                                //  html_content: description ? description: `<h4 style = "text-align:center; margin-top:10px">Not Found</h4>`
                             })
                        }}
                 >
                     <Button style={styles.viewMore}
                       title={'View More'}
                       textStyle={{color:Styles.white, fontSize: 14, marginHorizontal: 14,}}
                       To={true}
           
                       icon={'keyboard_arrow_right'}
                       iconStyle={{
                        marginRight:10,
                        color:Styles.white,
                        marginHorizontal: -2,
                        // marginTop:2,
                        fontSize: 16
                       }}
                       bold
                       size={11}
                     >
                        
                      
                     </Button>
                 </TouchableWithoutFeedback>

               </View>
           </View>
        </Surface>
    )
}

class TestSeriesTestList extends React.Component {
    state = {}
    componentDidMount() {                                                         
      this.fetchDataForTestSeriesList()
   }

   fetchDataForTestSeriesList = () => {
    // const testSeriesId = this.props.navigation.getParam('testSeriesId', null);
    // const subjectNames = this.props.navigation.getParam('subjectNames', null);

    const {location} = this.props; 
    const {state} =location || {};
    const {testSeriesId, subjectNames} = state || {};

 
    
    this.props.getTestSeriesTestList(testSeriesId);
        this.setState({
            subjectNames,
        }
    )  
   }

   componentWillUnmount() {      
       this.props.clearTestSeriesTestList();       
   }

   componentDidUpdate(prevProps) {
    if(prevProps.response !== this.props.response) {
        if(this.props.response) {
            // const message = this.props.response.data && this.props.response.data.message || 'Successfully payment is done';
            // this.showToaster(message, 2000);
            // this.props.getTestSeriesList();
            // setTimeout(() => {
            //     // this.props.navigation.navigate('Tests');
            // }, 3000);
        }
    }

    if(prevProps.paymentError !== this.props.paymentError) {
     
        // if(this.props.paymentError) {
           
        //   setTimeout(() => { 
        //     const errorInfo = this.props.paymentErrorMessage || 'failed..'

        //     // this.showToaster(errorInfo, 2000)
        //   }, 3000);
        // }
    }
}

showToaster = (msg='', time=1000) => this.setState({show: true, toasterMsg: msg})

makePayment = (transactionType, id, price) => {
    this.props.history.push("/Payment", {
      paymentInfo: {
        transactionType: transactionType,
        courseId: id,
        price: price,
        
      },
      examId: null,
    });
   } 
    render() {

        const {isPaid} = this.state;
        const {
           title,
           mock_series_code,
           actual_price,
           discount_price,
           is_discount,
           exam_code,
           is_daily_test,
           sortorder, 
           status,
           mock_tests =[],
           mock_series_payment=[],
           image_url,
           id,
           description,
        //    exam_code,
           exam_name,
           end_date_time,
           start_date_time,
           app_store_product_id

        }  = this.props.mockTestDetails || {};
        const {payment_id} = mock_series_payment[0] || {}
        const isFree = !(actual_price > 0) || (is_discount && !(discount_price > 0));

        // console.log(this.props);/
        const price = is_discount ? discount_price : actual_price;  
        const actualPrice = actual_price < 1 ?  true : false
        return (
            <>
             <Header
                title={title}
                // headerRight
                // headerRightClick={() => alert()}
            />
            {
                
                this.props.loading ? (
                    <View style={{ width: '100%', height: '90vh', justifyContent: 'center', alignItems: 'center' }}>
                    {/* <ActivityIndicator /> */}
                    <Image source={Loader} style={{width: 250, height: 250}}/>
                        </View>
                    ) : null
            }
            {
               !this.props.loading &&
           
            <Container maxWidth="lg">
            <div 
             className='main-component'
             >
            
                <View style={{width: '100%', height: '100%',}}>

                {
                    !!this.props.mockTestDetails && 
                    <View style={{ width: '100%', }}>
                        <View style={{ marginTop: 5,}}>
                            <TestSeriesDetailsComponent  
                                 seriesDetails={this.props.mockTestDetails}
                                isTestList={true}
                                makePayment={this.makePayment}
                            />
                        </View>
                         
                        <View style={{ paddingBottom: 20, marginBottom: 25, flexDirection:  _width <=780  ? 'column' : 'row',
                         justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap'}}>
                            {
                                 mock_tests && mock_tests.length > 0  ?  (
                                    <>
                                     {
                                          mock_tests.map((item, index) => {
                                              return(
                                                <TestListComponent
                                                testListTestData={item}
                                                //  subjectTitle={item.subjectTitle}
                                                //  title={item.title}
                                                //  dateOfList={item.date}
                                                //  isLock={item.isLock}
                                                //  image={item.image}
                                                navigation={this.props.history}
                                                paymentId={payment_id}
                                                price={price}
                                                mockSeriesCode={mock_series_code}   
                                                isPriceZero={isFree}
                                                appStoreProductId = {app_store_product_id}          
               
                                             />
                                              )
                                          })
                                     }
                                    </>
                                //     <FlatList
                                //      data={mock_tests}
                                //      renderItem={({item}) => (
                                //          <SlideUp
                                //          >
                                //          <TestListComponent
                                //             testListTestData={item}
                                //             //  subjectTitle={item.subjectTitle}
                                //             //  title={item.title}
                                //             //  dateOfList={item.date}
                                //             //  isLock={item.isLock}
                                //             //  image={item.image}
                                //             navigation={this.props.navigation}
                                //             paymentId={payment_id}
                                //             price={price}
                                //             mockSeriesCode={mock_series_code}   
                                //             isPriceZero={isFree}
                                //             appStoreProductId = {app_store_product_id}          
           
                                //          />
                                //          </SlideUp>
                                //      )}
                                //     keyExtractor={(item, index) => index.toString() }
                                  
                                //    />
                                ) : (
                                    <>
                                     {
                                          this.props.loading ? null : <Text style={{textAlign:'center', fontWeight:'500', marginTop:10,}}>You don't have any tests</Text>
                                     }
                                    </>
                                    
                                )


                                // testSeriesList.map((x, index) => {
                                //     return(
                                //         <TestListCom />
                                //         )
                                //     })
                                }
                        </View>
              </View>
                }
    
                 </View>
               <ToasterComponent
                show={this.state.show}
                message={this.state.toasterMsg}
               />
            </div>
            </Container>
            }
            </>
        )
    }
}




const styles = StyleSheet.create({
    mainWrapper:{
        flex:1,
    
       
    },
    testListWrapper: {
        elevation: 8,
        marginVertical: 3,
        marginHorizontal: 10,
        width: wp('95%'),
        minHeight: 65, 
        // paddingVertical: 6,
        alignSelf :'center',
        paddingHorizontal: 6
    },
    testSeries: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        // justifyContent: 'space-between'
  
    },
    leftSideDetails: {
        width: 48,
        height: 48,
        // marginRight: 10,
        
    },
    testImages: {
        marginHorizontal: 5,
        width: '100%',
        height: '100%',
        borderRadius:100,
        resizeMode: 'cover'
    },
    testTitle: {
        flex: 1,
        // flex: 1,
        fontSize: 13,
        color: Styles.testSeriesListColor,
        // fontWeight:"500",
        color:'#000',
        textTransform: 'capitalize',
        // marginRight: 10, 
        // alignSelf: 'flex-start'
        
       
    },
    rightSideDetails: {
        flex: 1,
        marginHorizontal: 15,
        flexDirection: 'column',

    },
    underLine: {
        // width: '80%',
        borderColor: Styles.testSeriesListColor,
        borderWidth: 0.4,
        marginVertical: 5,
        borderColor: '#00000024'

    },
    testBottomDetails: {
        flex:1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
     
        
    },
    subjectComponent: {
        paddingBottom: 2,
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 2,
        alignItems: 'center',
        opacity: 0.6,
        backgroundColor:'#e9e9e9',
        marginHorizontal:2,
        margin:2,       
        
    },
    listOfBoxes:{
        // width:wp('60%'),
        flexDirection:'row',
        alignItems:'center',
        marginHorizontal:2,
        flexWrap:"wrap",
       
        flex:1
        // borderWidth: 1
      
    },
    testDateText: {
        fontSize: 9,
        color: '#898989',
    
        marginRight: 5
    },
    lockImage: {
        marginRight: 5
    },
    subjectBoxTitle: {
        fontSize: 8,
        color: Styles.testSeriesListColor,
       
    },
    scheduleTest: {
        fontSize: 10,
        color: Styles.testSeriesListColor,
        fontWeight: '600'
       
    },
    testDetailsCom:{
        elevation: 5,
        marginVertical: 10,
        // marginHorizontal: wp(1),
        width: wp('95%'),
        height: 200,
        borderRadius: 15,
        alignSelf:'center',       
    },
    detailsWrapper:{
        // padding: 4,
        flex:1,
        flexDirection:'column',    
        justifyContent: 'space-between'
    },
    topBox:{
        width:'100%',
        // height:hp(15),
        borderTopLeftRadius:10,
        borderTopRightRadius:10,
        flexDirection:'row',
        backgroundColor:'#FAFAFA',
        height: 110,
        // backgroundColor: 'red',
    },
    imageComp:{
        width: 130,
        height: '100%',
        borderTopLeftRadius:10,
        // borderTopRightRadius:10,
    },
    seriesTitle:{
        flex: 1,
        // height: 130,
        // width:wp(70),
        // height:hp(15),
        // marginHorizontal:wp(2),
        flexDirection:'column',
        // marginVertical:hp(2),
        fontWeight: '600',
        // borderWidth: 1,
        alignSelf: 'flex-start',
        paddingRight: 8,
        paddingLeft: 8,
        marginTop: 4
    },
    seriesTitleText: {
        fontSize:16,
        fontWeight: '600',
        color:Styles.testSeriesListColor,
        lineHeight: 18,
        textTransform: 'capitalize'
    },
    testSeriesExam: {
        fontSize:12, 
        color:Styles.testSeriesListColor,  
        marginVertical: 8,
        fontWeight: '500',
        textTransform: 'uppercase'
    },
    purchasedText: {
        fontSize: 16, 
        marginRight:5,                               
        color: '#239A14', 
        alignItems:'center', 
        textTransform: 'capitalize',
    },
    priceList:{
        fontSize: 12,
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 4,        
    },
    priceTitle: {
        color: '#F5891F',
        fontSize: 12,
        paddingRight: 12,
        fontWeight: '700',
        // marginHorizontal:wp(3),
        // marginRight: 10
    },
    strikePrice: {
        fontWeight: '700',
        color: '#F5891F',
        fontSize: 12,
        textDecorationLine: 'line-through',
        paddingRight: 12,
    },
    dateWrapper: {
        flexDirection:'column',
        justifyContent:'center',
        alignItems: 'flex-start',       
    },
    flexRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dayText: {
        color: '#000',
        fontSize: 10,
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    monthText: {        
        fontSize: 1,
    },
    timeText: {
        color: '#000',
        fontSize: 15,
        // fontWeight: '500',
    },
    timerGifWrapper: {
        flexDirection: 'row',
        // flex: 1,
        // backgroundColor: '#ccc',
        
    },
    dashIcons: {
        marginHorizontal: 4,
        color:'#3758DB',
        fontSize: 8,
        // alignSelf: 'flex-end',
        // marginTop: 15
        marginBottom: -12
    },
      dateBox:{
        // width:wp(95),
        // height:hp(5),
        flexDirection:'row',
        justifyContent: 'space-between',
        alignItems:'center',
        flex: 1, 
        paddingHorizontal: 12,
        borderBottomWidth: 0.4,
        borderColor: '#ccc',
        // backgroundColor: 'red'
      },
      startTime:{
        //   width:wp(15),
          flexDirection:'column',
        //   marginHorizontal:wp(4),
          alignSelf:'center'

      },
      endTime:{
        // width:wp(30),
        alignSelf:'center',
        flexDirection:'column',
        // marginHorizontal:wp(5)


    },
    middleBox:{
        // width:wp(45),
        
    },
    startDate:{
        fontSize:wp(2),
        color:'#555',
       
        
    },
    timeStart:{
        fontSize:wp(2),
        color:'#555',
        // marginHorizontal:wp(1),
       
    },
    timeZone:{
        // fontSize:wp(3),
        color:'#555',
       
    },
    leftSymbols:{
        marginHorizontal:wp(1),
        color:'#3758DB',
        fontSize:wp(3),
       
    },
    rightSymbols:{
        marginHorizontal:wp(1),
        color:'#3758DB',
        fontSize:wp(3)
    },
    dividerLine: {
        borderWidth: 0.39,
        borderColor:'#ccc'
     },
     bottomDetails:{
        // width:wp(95),
        // height:hp(4),
        flexDirection:'row',
        justifyContent:'space-between',
        alignItems:'center',
        // height: '100%',
        //borderWidth: 1,`
       paddingHorizontal: 12,
       paddingVertical: 9
     },
     testCount:{
         flexDirection:'row',
        justifyContent:'center',
        alignItems:'center',
        // marginHorizontal:wp(4),
     },
     symbolOfCount:{
         width: 8,
         height: 8,
         borderRadius:100,
         backgroundColor:'#F5891F',
         justifyContent:'center',
         alignItems:'center'
     },
     count:{
         color:'#403F3F',
         fontSize: 12,
         marginHorizontal: -4

     },
     viewMore:{
        //  width:,
        //  height:hp(3),
         backgroundColor: Styles.primaryColor,
         flexDirection:'row',
        //  marginRight:4,
         justifyContent:'space-between',
         alignItems:'center',
         borderRadius:10,
        //  shadowColor: Styles.primaryColor,
        //  shadowRadius: 10,
        //  shadowOpacity: 0.6,
         elevation: 5,
        //  shadowOffset: {width: 0,height: 4},
        paddingHorizontal: 3,
        paddingVertical: 5
         
     },
     courseWrapper: {
        paddingHorizontal: 8,
        width:  _width <=780 ? '100%' : '48%',
        paddingVertical: 12,
        justifyContent: 'flex-start',
        // alignItems: '',
        marginHorizontal: 10,
        flexDirection: 'row',
        borderRadius: 10,
        marginBottom: 12,
        // borderColor: '#ccc' ,
        marginTop: 5,
        borderWidth: 3,
        borderColor: '#fff'
    },
    imageIcon: {
        marginLeft: 5,
        borderWidth: 2,
        borderColor: '#fff',
        width: 64,
        height: 64,
        borderRadius: 10


    },
    title: {
        fontSize: 18,
        color: 'rgba(0,0,0,0.7)',
        fontWeight: '700',
        paddingRight: 5

    },
});


const mapStatesToProps = state => {     
    const paymentStatus = subscriptionPlanPaymentStatus(state);    
    const {
        error: paymentError,
        errorInfo: paymentErrorMessage,
        loading: paymentLoading,
        response,
    } = paymentStatus;

    return {
        topicsInfo: state.libraryTopicsBySubject && state.libraryTopicsBySubject.response && state.libraryTopicsBySubject.response.library_topics,
        loading: state.libraryTopicsBySubject && state.libraryTopicsBySubject.loading,
        error: state.libraryTopicsBySubject && state.libraryTopicsBySubject.error,
        errorInfo: state.libraryTopicsBySubject && state.libraryTopicsBySubject.errInfo && state.libraryTopicsBySubject.errInfo.data && state.libraryTopicsBySubject.errInfo.data.message,
        paymentError,
        paymentErrorMessage,
        paymentLoading,
        response,
        testSeriesTestListDetails:  state.testSeriesTestListInfo && state.testSeriesTestListInfo.response && state.testSeriesTestListInfo.response.data
        &&state.testSeriesTestListInfo.response.data.tests_in_mockseries,
        loading: state.testSeriesTestListInfo && state.testSeriesTestListInfo.loading,    
        mockTestDetails: state.testSeriesTestListInfo && state.testSeriesTestListInfo.response && state.testSeriesTestListInfo.response.data
        &&state.testSeriesTestListInfo.response.data.mock_series_details, 
    }
    
   
                    
 };
 
 export default connect(mapStatesToProps, {
     getTestSeriesTestList, getTestSeriesList,
     clearTestSeriesTestList, checkoutCreateTest})(TestSeriesTestList);